import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArmSideNavComponent } from './arm-side-nav.component';
import {RouterModule} from '@angular/router';
import {MaterialModule} from '../../material.module';
import {LayoutModule} from '../layout/layout.module';

@NgModule({
  declarations: [
      ArmSideNavComponent
  ],
  exports: [
    ArmSideNavComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        LayoutModule
    ]
})
export class ArmSideNavModule { }
